import { useState, useEffect } from 'react';

const POINTER_HOVER_MQ = '(hover: hover) and (pointer: fine)';

/**
 * True when the primary pointer is fine (mouse-like) and can hover.
 * False on typical phones (coarse pointer and/or hover: none), so Tooltip and
 * slot hover previews stay tap-driven instead of opening on incidental hover.
 */
export function usePointerHover() {
    const [hasHover, setHasHover] = useState(() => (
        typeof window !== 'undefined' && window.matchMedia(POINTER_HOVER_MQ).matches
    ));

    useEffect(() => {
        const mq = window.matchMedia(POINTER_HOVER_MQ);
        const apply = () => setHasHover(mq.matches);
        apply();
        mq.addEventListener('change', apply);
        return () => mq.removeEventListener('change', apply);
    }, []);

    return hasHover;
}
